import { render, staticRenderFns } from "./UserHelpDesksIssueForm.vue?vue&type=template&id=ed5fdd60"
import script from "./UserHelpDesksIssueForm.vue?vue&type=script&lang=js"
export * from "./UserHelpDesksIssueForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports